import { Controller } from "@hotwired/stimulus"

// Bundles the referral-code copy into the store tap itself (docs/005 B4):
// one tap copies the code and continues to the App Store / Play Store link.
// The clipboard write must happen inside the tap's user gesture — browsers
// reject writes outside one — so we hold the navigation, write, then go.
//
// data-controller="store-tap" data-store-tap-code-value="abc12345"
// links: data-action="click->store-tap#visit"
export default class extends Controller {
  static values = { code: String }

  async visit(event) {
    // Modified clicks (cmd/ctrl/shift/alt, non-primary button) keep the native
    // open-in-new-tab behavior — no copy, no same-tab hijack.
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return

    const url = event.currentTarget?.href
    if (!this.codeValue || !url) return // nothing to copy — let the link behave normally

    event.preventDefault()
    try {
      // Cap the wait so a slow clipboard can never strand the tap on our page.
      await Promise.race([
        navigator.clipboard.writeText(this.codeValue),
        new Promise((resolve) => setTimeout(resolve, 400)),
      ])
    } catch {
      // Clipboard denied — the tap-to-copy block below the buttons remains.
    }
    window.location.assign(url)
  }
}
